//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.GetSimpleListTemplateQuery_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.GetSimpleListTemplateQuery_VariablesAdapter
import com.wintermar.inspection.graphql.selections.GetSimpleListTemplateQuerySelections
import com.wintermar.inspection.graphql.type.InspectionTemplateStatus
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.collections.List
import com.wintermar.inspection.graphql.type.Query as CompiledQuery

public data class GetSimpleListTemplateQuery(
  public val page: Int,
  public val pageSize: Int,
  public val status: Optional<InspectionTemplateStatus?> = Optional.Absent,
  public val archived: Optional<Boolean?> = Optional.Absent,
) : Query<GetSimpleListTemplateQuery.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    GetSimpleListTemplateQuery_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = GetSimpleListTemplateQuery_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledQuery.type
  )
  .selections(selections = GetSimpleListTemplateQuerySelections.__root)
  .build()

  @ApolloAdaptableWith(GetSimpleListTemplateQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val inspectionTemplates: InspectionTemplates,
  ) : Query.Data

  public data class InspectionTemplates(
    public val `data`: List<Data1>?,
  )

  public data class Data1(
    public val id: Any,
    public val name: String,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "f1e698716b8825e4e6149dc8b49dce781f2391d2c36dae675ecc5c59f1f4afbe"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query getSimpleListTemplate($page: Int!, $pageSize: Int!, $status: InspectionTemplateStatus, $archived: Boolean) {
     *   inspectionTemplates(query: {
     *     page: $page
     *     pageSize: $pageSize
     *     status: $status
     *     archived: $archived
     *   }
     *   ) {
     *     data {
     *       id
     *       name
     *     }
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query getSimpleListTemplate(${'$'}page: Int!, ${'$'}pageSize: Int!, ${'$'}status: InspectionTemplateStatus, ${'$'}archived: Boolean) { inspectionTemplates(query: { page: ${'$'}page pageSize: ${'$'}pageSize status: ${'$'}status archived: ${'$'}archived } ) { data { id name } } }"

    public const val OPERATION_NAME: String = "getSimpleListTemplate"
  }
}
